import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import Goals from "../../components/public/goal";
import Footer from "../../components/public/footer";

export default () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"ध्येय व उद्देश"} content={<Goals />} />
      <Footer />
    </>
  );
};
